import ApiClient from './ApiClient';

class TrackingSourcesAPI extends ApiClient {
  constructor() {
    super('tracking_sources', { accountScoped: true });
  }
}

export default new TrackingSourcesAPI();
